import Vue from "vue";
import VueRouter from "vue-router";
import HomeView from "../views/HomeView.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/home",
    name: "home",
    component: HomeView,
  },
  {
    path: "/",
    name: "index",
    redirect: "/home",
  },
  {
    path: "/about",
    name: "about",
    component: function () {
      return import("../views/AboutView.vue");
    },
  },
  {
    path: "/membership",
    name: "membership",
    component: function () {
      return import("../views/MemberShip.vue");
    },
  },
  {
    path: "/course",
    name: "course",
    component: function () {
      return import("../views/CourseView.vue");
    },
  },
  {
    path: "/download",
    name: "download",
    component: function () {
      return import("../views/DownLoad.vue");
    },
  },
];

const router = new VueRouter({
  routes,
});

export default router;
